import { IIntroductionLinkProps } from '../components/home-components/instruction-link';

export const homePageInstructionsMobileData: IIntroductionLinkProps[] = [
  {
    name: 'VIEW NOTES AND HIGHLIGHTS IN THE APP FEED',
    pdfUrl: '/documents/mobile/See Notes and Highlights (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'FIND AND FOLLOW A LEADER',
    pdfUrl: '/documents/mobile/Find and Follow a Leader (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'COPY LEADER POSTS TO YOUR LIBRARY',
    pdfUrl: '/documents/mobile/Copy Leader Posts to Library (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'VIEW LIBRARY, ADD AFFIRMATIONS',
    pdfUrl: '/documents/mobile/View Library and Add Affirmations (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'SHARE LEADER POSTS',
    pdfUrl: '/documents/mobile/Share Leader Posts (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
];
